const copy = {
  Français: {
    nav: {
      home: "Accueil",
      about: "À propos",
      services: "Services",
      expertises: "Expertises",
      method: "Méthode",
      organisation: "Notre organisation",
      valueMethods: "Méthodes de création de valeur",
      resources: "Ressources",
      downloads: "Téléchargements",
      gallery: "Galerie",
      contact: "Contact",
      contactCta: "Nous contacter",
    },
    hero: {
      alt: "Équipe AMT Systems-Engineering en session de conception",
      title: "Ingénierie des systèmes au service de votre entreprise et de votre projet.",
      text: "Depuis 2024, AMT Systems-Engineering SARL accompagne les entreprises, institutions et jeunes entrepreneurs dans la conception et le déploiement de solutions technologiques utiles à l’émergence locale.",
      cta: "Nous contacter",
      secondary: "Découvrir nos services",
    },
    stats: {
      aria: "AMT en chiffres",
      local: "Ancrage local, Cameroun",
      expertise: "6 expertises",
      expertiseText: "Systèmes, data, software, hardware",
      since: "Depuis 2024",
      sinceText: "Innovation utile et mesurable",
      source: "1 source",
      sourceText: "De l’idée au déploiement",
    },
    statement: {
      aria: "Engagement AMT Systems-Engineering",
      first: "Des solutions locales pour un besoin local.",
    },
    about: {
      eyebrow: "À propos",
      title: "Comprendre les défis, développer les compétences et construire des solutions utiles à l’Afrique.",
      context: "Le contexte",
      challengesTitle: "Les défis de l’Afrique subsaharienne",
      challengesText: "L’Afrique subsaharienne doit accélérer sa transformation tout en répondant à des besoins industriels, sociaux et économiques complexes.",
      challenge1: "Renforcer les compétences locales",
      challenge2: "Adapter les technologies au terrain",
      challenge3: "Relier innovation et développement durable",
      responseLead: "AMT répond",
      response: " par une approche intégrée : transformer les besoins en solutions et créer un pont entre savoirs académiques, expertise locale et bonnes pratiques internationales.",
      vision: "Notre vision",
      visionTextBefore: "Positionner le continent africain comme ",
      visionStrong: "leader technologique",
      visionTextAfter: " en faisant de l’ingénierie des systèmes un moteur de transformation.",
      mission: "Notre mission",
      missionTextBefore: "Concevoir et déployer des ",
      missionStrong: "solutions robustes et innovantes",
      missionTextAfter: " adaptées au contexte africain, avec une expertise locale.",
      principles: "Nos repères",
      valuesTitle: "Les valeurs qui nous guident",
      value1Lead: "Innovation",
      value1: " utile et adaptée au contexte local",
      value2Lead: "Excellence",
      value2: ", rigueur et fiabilité",
      value3Lead: "Intégrité",
      value3: " et responsabilité",
      value4Lead: "Collaboration",
      value4: " et transmission des savoirs",
      value5Lead: "Impact durable",
      value5: " et développement inclusif",
      means: "Les moyens d’agir",
      skillsTitle: "Les compétences au service de la mission",
      skillsText: "Pour atteindre cette vision, AMT rassemble et développe des compétences complémentaires.",
      skillSystems: "Ingénierie des systèmes",
      skillHw: "Hardware & software",
      skillData: "Data & IA",
      skillMech: "Mécanique",
      skillProjects: "Projets",
      skillLeadership: "Leadership",
      teamKicker: "Notre force collective",
      teamTitle: "Une équipe au croisement de plusieurs expertises",
      teamText: "AMT s’appuie sur des profils complémentaires pour transformer chaque besoin en solution cohérente, réalisable et durable.",
      exec: "Stratégie, finances et administration d’AMT.",
      cto: "Laboratoire, innovation et choix technologiques.",
      cmo: "Marketing, communication et activités commerciales.",
      leaders: "Conception et pilotage de projets de bout en bout.",
      associates: "Développeurs et étudiants mettant en œuvre les projets.",
      partners: "Experts internationaux pour renforcer nos compétences.",
    },
    services: {
      eyebrow: "Nos services",
      title: "Les expertises qui répondent à vos défis",
      intro: "AMT propose une gamme complète de services d'ingénierie des systèmes et de transformation digitale. Nous aidons les organisations africaines à relever leurs défis par des solutions technologiques robustes, innovantes et adaptées au contexte local.",
      more: "En savoir plus",
      systems: "Ingénierie complète : exigences, architecture hardware/software, vérification et validation. Conception robuste de systèmes complexes.",
      data: "Acquisition, transformation, analyse et modélisation des données pour éclairer les opérations et les décisions stratégiques.",
      web: "Applications web, mobiles et embarquées conçues pour vos processus métier et l’expérience de vos utilisateurs.",
      proto: "Modélisation CAD, impression 3D, scan 3D, layout hardware et prototypage PCB. De l’idée au démonstrateur technique.",
      supply: "Identification des besoins, gestion des fournisseurs et optimisation de la chaîne d’approvisionnement, avec un réseau d’associés.",
      ai: "Écosystème intégré : hardware, software, mécanique et intelligence artificielle, livré depuis une seule source.",
    },
    expertises: {
      eyebrow: "Nos expertises",
      title: "Des capacités complémentaires pour des solutions intégrées.",
      intro: "AMT associe l'ingénierie des systèmes, le développement hardware et software, l'analyse de données, l'intelligence artificielle et l'ingénierie mécanique. Cette expertise multidisciplinaire nous permet de concevoir, réaliser et accompagner des solutions adaptées aux besoins concrets de nos clients.",
      aria: "Capacités AMT",
      systemsLabel: "Systèmes",
      systemsTitle: "Ingénierie des systèmes",
      systemsText: "Analyse des exigences, architecture, vérification et validation de systèmes complexes.",
      digitalLabel: "Numérique",
      digitalTitle: "Hardware & software",
      digitalText: "Conception d'applications, systèmes embarqués, interfaces et composants électroniques.",
      dataLabel: "Données",
      dataTitle: "Data & intelligence artificielle",
      dataText: "Acquisition, modélisation et valorisation des données pour éclairer la décision.",
      designLabel: "Conception",
      designTitle: "Ingénierie mécanique",
      designText: "Modélisation, prototypage et intégration des éléments matériels dans la solution finale.",
      leadLabel: "Pilotage",
      leadTitle: "Gestion de projets",
      leadText: "Organisation, suivi et coordination pour faire progresser chaque projet avec rigueur.",
      impactLabel: "Impact",
      impactTitle: "Leadership & entrepreneuriat",
      impactText: "Mobilisation des talents et création de valeur durable au sein des organisations.",
    },
    projects: {
      eyebrow: "Projets",
      title: "Des missions structurées pour créer de la valeur durable.",
      coming: "Études de cas à venir",
      text: "Nos projets de référence seront bientôt présentés ici : transformations numériques, innovations industrielles et déploiements technologiques.",
      cta: "Discutons de votre projet",
    },
    organisation: {
      eyebrow: "Notre organisation",
      title: "Nos procédés",
      lede: "Une organisation qui relie le pilotage, la relation client, la réalisation et les fonctions support autour d’un même objectif : livrer une solution utile et fiable.",
      aria: "Paysage des procédés AMT",
      direction: "Direction",
      exec: "Management exécutif",
      execLead: "Stratégie",
      execText: ", finances et administration au service de l’ensemble de l’organisation.",
      input: "Entrée",
      acquisition: "Marketing & acquisition",
      acquisitionText: "Recueillir le besoin, comprendre le contexte et établir la relation avec le client.",
      delivery: "Réalisation",
      development: "Développement",
      developmentText: "Concevoir, réaliser, vérifier et améliorer les solutions tout au long du projet.",
      output: "Sortie",
      marketing: "Marketing & livraison",
      marketingText: "Livrer la solution, accompagner son appropriation et maintenir la relation client.",
      support: "Fonctions support & transverses",
      hr: "Ressources humaines",
      quality: "Contrôle qualité",
      accounting: "Comptabilité & inventaire",
      procurement: "Achats",
      it: "IT, administration & partenaires",
    },
    methods: {
      eyebrow: "Méthode",
      title: "Méthodes de création de valeur",
      lede: "Notre approche centrée client transforme un besoin réel en solution mesurable. Chaque étape alimente la suivante et les retours du terrain nourrissent l’amélioration continue.",
      listen: "Écouter",
      listenText: "Comprendre les attentes, contraintes et priorités des utilisateurs et des parties prenantes.",
      frame: "Cadrer",
      frameText: "Clarifier le besoin, les résultats attendus, le périmètre et les critères de réussite.",
      design: "Concevoir",
      designText: "Co-construire une solution réaliste, adaptée au contexte et techniquement robuste.",
      proto: "Prototyper",
      protoText: "Rendre la solution concrète rapidement afin de valider les choix essentiels.",
      deploy: "Déployer",
      deployText: "Mettre en œuvre, accompagner les équipes et assurer une adoption opérationnelle.",
      improve: "Améliorer",
      improveText: "Mesurer les résultats, recueillir les retours et faire évoluer la solution durablement.",
    },
    resources: {
      eyebrow: "Ressources",
      title: "Téléchargements",
      lede: "Consultez notre brochure pour découvrir la vision, les services et la démarche de création de valeur d’AMT.",
      cardTitle: "Brochure AMT Systems-Engineering",
      cardText: "Présentation de l’entreprise, des expertises et de notre méthode de travail.",
      download: "Télécharger la brochure",
    },
    gallery: {
      eyebrow: "Galerie",
      title: "L’équipe au travail",
      alt: "Session de travail AMT Systems-Engineering SARL",
      caption: "Conception collaborative",
      captionText: "Ingénierie, prototypage et solutions numériques depuis Douala.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Construisons ensemble des solutions utiles et durables.",
      text: "Nous accompagnons les entreprises, institutions et jeunes talents dans la création de solutions technologiques adaptées à leur contexte et à leurs ambitions de croissance.",
      location: "Localisation",
      locationValue: "Douala, Bonamoussadi, Terminus, Cameroun",
      phone: "Téléphone",
      name: "Nom",
      company: "Entreprise",
      message: "Message",
      submit: "Envoyer ma demande",
      success: "Votre message a été préparé dans votre client email. Vous pouvez l’envoyer directement.",
      mailSubject: "Demande de contact",
      mailClient: "Client",
      mailName: "Nom",
      mailEmail: "Email",
      mailCompany: "Entreprise",
      mailMessage: "Message",
    },
    footer: {
      about: "AMT Systems-Engineering SARL est une structure basée à Douala, au Cameroun, engagée dans la promotion de l’ingénierie des systèmes comme facteur de développement, d’innovation et d’entrepreneuriat.",
      expertise: "Expertises",
      systems: "Ingénierie de systèmes",
      consulting: "Conseil stratégique",
      digital: "Solutions numériques",
      projects: "Pilotage de projets",
      training: "Formation et accompagnement",
      navigation: "Navigation",
      country: "Cameroun",
      privacy: "Confidentialité",
      terms: "Conditions",
    },
  },
  English: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      expertises: "Expertise",
      method: "Approach",
      organisation: "Our organization",
      valueMethods: "Value creation methods",
      resources: "Resources",
      downloads: "Downloads",
      gallery: "Gallery",
      contact: "Contact",
      contactCta: "Contact us",
    },
    hero: {
      alt: "AMT Systems-Engineering team in a design session",
      title: "Systems engineering for your business and your project.",
      text: "Since 2024, AMT Systems-Engineering SARL has supported companies, institutions and young entrepreneurs in designing and deploying technology solutions that contribute to local development.",
      cta: "Contact us",
      secondary: "Explore our services",
    },
    stats: {
      aria: "AMT at a glance",
      local: "Local roots, Cameroon",
      expertise: "6 areas of expertise",
      expertiseText: "Systems, data, software, hardware",
      since: "Since 2024",
      sinceText: "Useful, measurable innovation",
      source: "One source",
      sourceText: "From idea to deployment",
    },
    statement: {
      aria: "AMT Systems-Engineering commitment",
      first: "Local solutions for local needs.",
    },
    about: {
      eyebrow: "About",
      title: "Understand challenges, develop skills and build solutions that serve Africa.",
      context: "The context",
      challengesTitle: "The challenges of sub-Saharan Africa",
      challengesText: "Sub-Saharan Africa must accelerate its transformation while addressing complex industrial, social and economic needs.",
      challenge1: "Strengthen local skills",
      challenge2: "Adapt technologies to local realities",
      challenge3: "Connect innovation and sustainable development",
      responseLead: "AMT responds",
      response: " through an integrated approach: turning needs into solutions and creating a bridge between academic knowledge, local expertise and international best practices.",
      vision: "Our vision",
      visionTextBefore: "Position the African continent as a ",
      visionStrong: "technology leader",
      visionTextAfter: " by making systems engineering a driver of transformation.",
      mission: "Our mission",
      missionTextBefore: "Design and deploy ",
      missionStrong: "robust and innovative solutions",
      missionTextAfter: " adapted to the African context, with local expertise.",
      principles: "Our principles",
      valuesTitle: "The values that guide us",
      value1Lead: "Innovation",
      value1: " that is useful and adapted to local realities",
      value2Lead: "Excellence",
      value2: ", rigor and reliability",
      value3Lead: "Integrity",
      value3: " and responsibility",
      value4Lead: "Collaboration",
      value4: " and knowledge sharing",
      value5Lead: "Sustainable impact",
      value5: " and inclusive development",
      means: "Our capabilities",
      skillsTitle: "Skills serving the mission",
      skillsText: "To achieve this vision, AMT brings together and develops complementary skills.",
      skillSystems: "Systems engineering",
      skillHw: "Hardware & software",
      skillData: "Data & AI",
      skillMech: "Mechanical engineering",
      skillProjects: "Projects",
      skillLeadership: "Leadership",
      teamKicker: "Our collective strength",
      teamTitle: "A team at the intersection of several areas of expertise",
      teamText: "AMT relies on complementary profiles to turn every need into a coherent, achievable and sustainable solution.",
      exec: "AMT strategy, finance and administration.",
      cto: "Laboratory, innovation and technology choices.",
      cmo: "Marketing, communications and commercial activities.",
      leaders: "End-to-end project design and management.",
      associates: "Developers and students implementing projects.",
      partners: "International experts strengthening our capabilities.",
    },
    services: {
      eyebrow: "Our services",
      title: "Expertise that answers your challenges",
      intro: "AMT offers a complete range of systems engineering and digital transformation services. We help African organizations meet their challenges with robust, innovative technology solutions adapted to the local context.",
      more: "Learn more",
      systems: "End-to-end engineering: requirements, hardware/software architecture, verification and validation. Robust design for complex systems.",
      data: "Data acquisition, transformation, analysis and modeling to inform operations and strategic decisions.",
      web: "Web, mobile and embedded applications designed for your business processes and user experience.",
      proto: "CAD modeling, 3D printing, 3D scanning, hardware layout and PCB prototyping. From idea to technical demonstrator.",
      supply: "Requirements identification, supplier management and supply-chain optimization through a network of associates.",
      ai: "An integrated ecosystem of hardware, software, mechanics and artificial intelligence, delivered from a single source.",
    },
    expertises: {
      eyebrow: "Our expertise",
      title: "Complementary capabilities for integrated solutions.",
      intro: "AMT combines systems engineering, hardware and software development, data analysis, artificial intelligence and mechanical engineering. This multidisciplinary expertise allows us to design, build and support solutions adapted to our clients' concrete needs.",
      aria: "AMT capabilities",
      systemsLabel: "Systems",
      systemsTitle: "Systems engineering",
      systemsText: "Requirements analysis, architecture, verification and validation of complex systems.",
      digitalLabel: "Digital",
      digitalTitle: "Hardware & software",
      digitalText: "Design of applications, embedded systems, interfaces and electronic components.",
      dataLabel: "Data",
      dataTitle: "Data & artificial intelligence",
      dataText: "Data acquisition, modeling and use to inform decisions.",
      designLabel: "Design",
      designTitle: "Mechanical engineering",
      designText: "Modeling, prototyping and integration of hardware into the final solution.",
      leadLabel: "Delivery",
      leadTitle: "Project management",
      leadText: "Organization, monitoring and coordination to move every project forward with rigor.",
      impactLabel: "Impact",
      impactTitle: "Leadership & entrepreneurship",
      impactText: "Mobilizing talent and creating lasting value within organizations.",
    },
    projects: {
      eyebrow: "Projects",
      title: "Structured engagements that create lasting value.",
      coming: "Case studies coming soon",
      text: "Our reference projects will be presented here soon: digital transformations, industrial innovations and technology deployments.",
      cta: "Let's discuss your project",
    },
    organisation: {
      eyebrow: "Our organization",
      title: "Our processes",
      lede: "An organization that connects leadership, client relationships, delivery and support functions around one goal: delivering a useful and reliable solution.",
      aria: "AMT process landscape",
      direction: "Leadership",
      exec: "Executive management",
      execLead: "Strategy",
      execText: ", finance and administration serving the entire organization.",
      input: "Input",
      acquisition: "Marketing & acquisition",
      acquisitionText: "Gather the need, understand the context and build the client relationship.",
      delivery: "Delivery",
      development: "Development",
      developmentText: "Design, build, verify and improve solutions throughout the project.",
      output: "Output",
      marketing: "Marketing & delivery",
      marketingText: "Deliver the solution, support its adoption and maintain the client relationship.",
      support: "Support and cross-functional functions",
      hr: "Human resources",
      quality: "Quality control",
      accounting: "Accounting & inventory",
      procurement: "Procurement",
      it: "IT, administration & partners",
    },
    methods: {
      eyebrow: "Approach",
      title: "Value creation methods",
      lede: "Our customer-centered approach turns a real need into a measurable solution. Each step informs the next, while field feedback drives continuous improvement.",
      listen: "Listen",
      listenText: "Understand the expectations, constraints and priorities of users and stakeholders.",
      frame: "Frame",
      frameText: "Clarify the need, expected results, scope and success criteria.",
      design: "Design",
      designText: "Co-create a realistic solution that fits the context and is technically robust.",
      proto: "Prototype",
      protoText: "Make the solution concrete quickly in order to validate essential choices.",
      deploy: "Deploy",
      deployText: "Implement the solution, support teams and ensure operational adoption.",
      improve: "Improve",
      improveText: "Measure results, collect feedback and evolve the solution over time.",
    },
    resources: {
      eyebrow: "Resources",
      title: "Downloads",
      lede: "Read our brochure to discover AMT's vision, services and value creation approach.",
      cardTitle: "AMT Systems-Engineering brochure",
      cardText: "An overview of the company, our expertise and our working method.",
      download: "Download the brochure",
    },
    gallery: {
      eyebrow: "Gallery",
      title: "The team at work",
      alt: "AMT Systems-Engineering SARL working session",
      caption: "Collaborative design",
      captionText: "Engineering, prototyping and digital solutions from Douala.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's build useful and sustainable solutions together.",
      text: "We support companies, institutions and young talents in creating technology solutions adapted to their context and growth ambitions.",
      location: "Location",
      locationValue: "Douala, Bonamoussadi, Terminus, Cameroon",
      phone: "Phone",
      name: "Name",
      company: "Company",
      message: "Message",
      submit: "Send my request",
      success: "Your message has been prepared in your email client. You can send it directly.",
      mailSubject: "Contact request",
      mailClient: "Client",
      mailName: "Name",
      mailEmail: "Email",
      mailCompany: "Company",
      mailMessage: "Message",
    },
    footer: {
      about: "AMT Systems-Engineering SARL is based in Douala, Cameroon, and promotes systems engineering as a driver of development, innovation and entrepreneurship.",
      expertise: "Expertise",
      systems: "Systems engineering",
      consulting: "Strategic consulting",
      digital: "Digital solutions",
      projects: "Project management",
      training: "Training and support",
      navigation: "Navigation",
      country: "Cameroon",
      privacy: "Privacy",
      terms: "Terms",
    },
  },
};

export default copy;
